import { Box, Button, FormControl, FormLabel, Heading, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useHookForm } from '@/hooks/useHookForm';

import { FormControlError } from '@/components/FormControlError/FormControlError';
import MemberNumberInput from '@/components/UI';

import { AppService } from '@/services';
import { onlyNumberValidation } from '@/validators';

interface RemindPasswordFormProps {
    onSubmit?: (memberNumber: string) => void;
}

interface RemindPasswordForm {
    memberNumber: string;
}

export function RemindPasswordForm(props: RemindPasswordFormProps) {
    const instanceCountryCode = useMemo(() => AppService.getAppCountryCode(), []);
    const { formState, register, handleSubmit } = useHookForm<RemindPasswordForm>();

    const onSubmit = (data: RemindPasswordForm) => {
        const memberNumber = `${instanceCountryCode}-${data.memberNumber.trim()}`;
        props?.onSubmit?.(memberNumber);
    };

    const userFormControl = register('memberNumber', {
        required: {
            value: true,
            message: 'field-is-required'
        },
        validate: (value) => onlyNumberValidation(value)
    });

    return (
        <>
            <Heading textAlign="center">
                <FormattedMessage id="page.remind-password.title"></FormattedMessage>
            </Heading>
            <Text maxW="280px" mx="auto" mt={2} textAlign="center" fontSize="sm">
                <FormattedMessage id="page.remind-password.description"></FormattedMessage>
            </Text>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Box maxW="350px" mx="auto" mt={4}>
                    <FormControl isRequired>
                        <FormLabel color="#181E20" fontWeight="600" mb={2}>
                            <FormattedMessage id="member-number"></FormattedMessage>
                        </FormLabel>
                        <FormControlError control={userFormControl} formState={formState}>
                            <MemberNumberInput formControlRef={userFormControl} />
                        </FormControlError>
                    </FormControl>
                    <Button
                        type="submit"
                        mx="auto"
                        display="block"
                        my={6}
                        px={7}
                        colorScheme="blue"
                    >
                        <FormattedMessage id="send" />
                    </Button>
                </Box>
            </form>
        </>
    );
}
